import { create } from 'zustand';

interface AuthStore {
  token: any,
  setAuthToken: (token:any) => void,
}

const useAuthStore = create<AuthStore>((set) => ({
  token: null,
  setAuthToken: (token) => set({token: token}),
}));

export { useAuthStore };